import React from 'react';
import { Helmet } from 'react-helmet-async';
import './LegalPages.css';

const About = () => {
  return (
    <>
      <Helmet>
        <title>About - One Piece Trivia | The Ultimate Anime Quiz Game</title>
        <meta name="description" content="Learn about One Piece Trivia - the ultimate free anime quiz game. Test your knowledge of One Piece characters, devil fruits, and more!" />
        <link rel="canonical" href="https://www.onepiecetrivia.com/about" />
      </Helmet>

      <div className="legal-page-container">
        <div className="legal-page-content about-page">
          <h1>About One Piece Trivia</h1>

          <section className="about-hero">
            <p className="tagline">
              The Ultimate One Piece Quiz Experience
            </p>
          </section>

          <section>
            <h2>What is One Piece Trivia?</h2>
            <p>
              One Piece Trivia is a free online quiz game designed for fans of the legendary
              anime and manga series One Piece. Whether you're a casual viewer or a die-hard
              nakama, our quizzes will challenge your knowledge and test how well you really
              know the world of pirates, devil fruits, and the Grand Line!
            </p>
          </section>

          <section>
            <h2>Our Quiz Games</h2>
            <div className="quiz-list">
              <div className="quiz-item">
                <h3>Character Quiz</h3>
                <p>
                  Can you identify One Piece characters just by looking at them? From the
                  Straw Hat crew to the Yonko, Marines to Revolutionaries - test your
                  character recognition skills!
                </p>
              </div>

              <div className="quiz-item">
                <h3>Image Quiz</h3>
                <p>
                  Match character names to their images in this visual memory challenge.
                  How quickly can you identify the faces of the One Piece universe?
                </p>
              </div>

              <div className="quiz-item">
                <h3>Devil Fruit Quiz</h3>
                <p>
                  Do you know which Devil Fruit belongs to which character? From Paramecia
                  to Logia to Zoan types - prove your Devil Fruit expertise!
                </p>
              </div>
            </div>
          </section>

          <section>
            <h2>How to Play</h2>
            <ul>
              <li>Choose your quiz type from the home screen</li>
              <li>Answer 15 questions per round</li>
              <li>Beat the 15-second timer for each question</li>
              <li>Use up to 6 passes if you're stuck</li>
              <li>Try to achieve the highest score possible!</li>
            </ul>
          </section>

          <section>
            <h2>For the Fans, By the Fans</h2>
            <p>
              One Piece Trivia was created by passionate fans of the series. We believe in
              providing a fun, free, and engaging way for the community to celebrate their
              love for Oda's masterpiece.
            </p>
            <p>
              Our questions are regularly updated to include new characters and content
              from the ongoing series. From Romance Dawn to the current arc, we've got
              it all covered!
            </p>
          </section>

          <section>
            <h2>Disclaimer</h2>
            <p>
              One Piece Trivia is a fan-made project and is not affiliated with, endorsed by,
              or connected to Eiichiro Oda, Shueisha, Toei Animation, or Funimation. All
              One Piece content and imagery belong to their respective copyright holders.
            </p>
          </section>

          <section>
            <h2>Start Your Adventure!</h2>
            <p>
              Ready to prove you're the ultimate One Piece fan? Head back to the{' '}
              <a href="/" className="home-link">home page</a> and start playing now!
            </p>
          </section>
        </div>
      </div>
    </>
  );
};

export default About;
